export const BASIC_DETAILS_LABELS = {
    HEADING: 'Basic Details',
    FOUNDED: 'Founded',
    ENTITY_STATUS: 'Entity Status',
    LAST_FILING_DATE: 'Last Filing Date',
    LAST_AGM: 'Last AGM',
    PAN: 'PAN',
    CIN: 'CIN',
    LLPIN: 'LLPIN',
    GST: 'GST',
    LEI: 'LEI',
    ADDRESS: 'Address',
    DATA_AS_OF: 'Data as of',
    LEI_STATUS: 'Status',
    LEI_REGISTRATION_DATE: 'Registration Date',
    LEI_LAST_UPDATE: 'Last Update',
    LEI_NEXT_RENEWAL: 'Next Renewal',
    PAID_UP_CAPITAL: 'Paid Up Capital',
    AUTHORIZED_CAPITAL: 'Authorized Capital',
    SUM_OF_CHARGES: 'Sum of Charges',
    MCA_COMPLIANCE: 'MCA Compliance',
    // LLP-only rows; a company response carries none of them.
    LAST_FINANCIAL_REPORTING: 'Last Financial Reporting',
    LAST_ANNUAL_RETURNS_FILED: 'Last Annual Returns Filed',
    TOTAL_OBLIGATION_OF_CONTRIBUTION: 'Obligation of Contribution',
    TOTAL_CONTRIBUTION_RECEIVED: 'Contribution Received',
} as const;
